import { render, staticRenderFns } from "./PlayerCore.vue?vue&type=template&id=306ff006&scoped=true&"
import script from "./PlayerCore.vue?vue&type=script&lang=js&"
export * from "./PlayerCore.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCore.vue?vue&type=style&index=0&id=306ff006&lang=scss&scoped=true&"
import style1 from "./PlayerCore.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ff006",
  null
  
)

export default component.exports